var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberSlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#a6acb5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.72,5.63A.89.89,0,0,1,13.66,5h.21a1,1,0,0,1,.93.93l1,8a1.06,1.06,0,0,1-2.11.12L13.12,9l-2,4a1.33,1.33,0,0,1-1.16.88A1.3,1.3,0,0,1,8.82,13l-2-4-.61,5.09a1,1,0,1,1-2-.09l1-8a1,1,0,0,1,.92-1h.21a.9.9,0,0,1,1,.63L10,11.42Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberSlot);
export default __webpack_public_path__ + "static/media/member-slot.5a3c1c083c7bf6c883df25ab6fac67f9.svg";
export { ForwardRef as ReactComponent };